import type { DripsyColor } from "@utils";
import * as React from "react";
import Svg, { Path } from "react-native-svg";
import { useDripsyColor } from "@utils";

function ArrowTopRight({ size, color }: { size: number; color: DripsyColor }) {
  const finalColor = useDripsyColor({ color });
  return (
    <Svg fill="none" viewBox="0 0 24 24" strokeWidth={1.5} width={size} height={size} stroke={finalColor}>
      <Path
        strokeLinecap="round"
        fill="none"
        strokeLinejoin="round"
        d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
      />
    </Svg>
  );
}
export default ArrowTopRight;
